import "./ActionCell.scss";

import { Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

import { EditIcon, ThreeDotsIcon } from "../icons";

interface IProps {
  disableDeleteBtn?: boolean;
  onEditClick?: () => void;
  onDeleteClick?: (() => void) | null;
}

const ActionCell: React.FC<IProps> = ({
  onEditClick,
  onDeleteClick,
  disableDeleteBtn,
}) => {
  const handleDeleteClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onDeleteClick) {
      e.stopPropagation();
      onDeleteClick();
    }
  };
  const handleEditClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onEditClick) {
      e.stopPropagation();
      onEditClick();
    }
  };
  return (
    <div className="table-buttons-wrapper">
      {onEditClick && (
        <Button
          variant="light"
          className="table-action-button d-none d-lg-block"
          data-testid="edit-button"
          onClick={onEditClick}
        >
          <span className="menu-icon p-0">
            <EditIcon />
          </span>
        </Button>
      )}

      <Dropdown className="actions-dropdown">
        <Dropdown.Toggle
          data-testid="popover-trigger"
          variant="outline-light"
          className={`no-arrow table-action-button ${
            onDeleteClick ? "" : "d-lg-none"
          }`}
        >
          <ThreeDotsIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu renderOnMount={false}>
          <Dropdown.Item
            className="dropdown-item d-lg-none"
            onClick={handleEditClick}
          >
            <span>Edit</span>
          </Dropdown.Item>

          {onDeleteClick && (
            <Dropdown.Item
              className={disableDeleteBtn ? "disabled" : ""}
              onClick={handleDeleteClick}
              aria-disabled={disableDeleteBtn}
              data-testid="delete-btn"
            >
              <span>Delete</span>
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export { ActionCell };
